import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { CustomInput } from "ui/Input";
import { InvoiceFilter } from "api/accounting";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: InvoiceFilter) => void;
	filterOptions: InvoiceFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [tempFilter, setTempFilter] = useState<Partial<InvoiceFilter>>({});

	const applyInvoiceNumber = () => {
		const newValue = tempFilter.invoiceNumber || "";
		const currentValue = filterOptions.invoiceNumber || "";
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			invoiceNumber: tempFilter.invoiceNumber,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyFromDate = () => {
		const newValue = tempFilter.fromDate;
		if (newValue === undefined || newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = tempFilter.toDate;
		if (newValue === undefined || newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items invoice-filter-items">
				<div className="invoice-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("FromDate")}
						format={DATE_FORMAT}
						className="height-inherit"
						style={{ width: "100%" }}
						value={tempFilter.fromDate !== undefined ? tempFilter.fromDate : filterOptions.fromDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, fromDate: e.target.value })
						}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div className="invoice-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
						value={tempFilter.toDate !== undefined ? tempFilter.toDate : filterOptions.toDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, toDate: e.target.value })
						}
						onBlur={() => applyToDate()}
					/>
				</div>
				<div className="invoice-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerLedgerAccountNumber || null,
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div className="invoice-filter-field" style={{ width: "170px" }}>
					<CustomInput
						onChange={(e) => setTempFilter({ ...tempFilter, invoiceNumber: e })}
						label={t("InvoiceNumber")}
						placeholder=" "
						style={{ width: "100%" }}
						value={tempFilter.invoiceNumber}
						onBlur={() => applyInvoiceNumber()}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyInvoiceNumber();
						}}
					/>
				</div>
			</div>

			<div className="filter-end-btn invoice-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
